// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event-top__stream[data-v-5162fd6d]{width:100%;aspect-ratio:16/9;border-radius:12px;overflow:hidden}.event-top__stream.levitate[data-v-5162fd6d]{position:fixed;top:0;left:0;width:100%;aspect-ratio:16/9;z-index:100;border-radius:0}.event-top__stream.levitate.cover[data-v-5162fd6d]{height:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
